import { render, staticRenderFns } from "./NotificationRedAlertIcon.vue?vue&type=template&id=e4bf116e&"
import script from "./NotificationRedAlertIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationRedAlertIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports